import { TagType } from '../../../../src/constants';

interface Trial {
  raw: { trialenrollingstatus: string; isvirtual: string };
}

const getColor = (tag: TagType, props: any, defaultColor?: string): string => {
  const colorMap: Record<TagType, string> = {
    [TagType.ENROLLING]: props?.enrolling?.value || defaultColor,
    [TagType.NOT_YET_ENROLLING]: props?.notYetEnrolling?.value || defaultColor,
    [TagType.GOOD_MATCH]: props?.goodMatch?.value || '#077D86',
    [TagType.VIRTUAL]: props?.virtual?.value || '#C42EA5',
  };
  return colorMap[tag];
};
export const getStatusTags = (
  trial: Trial,
  isGoodMatch: boolean,
  goodMatchLabel: string,
  virtualLabel: string,
  enrollingLabel: string,
  notYetEnrollingLabel: string,
  props?: any,
  defaultColor?: string
): { label: string; type: TagType; color: string }[] => {
  const tags: { label: string; type: TagType; color: string }[] = [];
  const status = trial?.raw?.trialenrollingstatus;
  const isVirtual = Boolean(trial?.raw?.isvirtual || false);

  if (status === 'Enrolling' && isGoodMatch) {
    tags.push({
      label: goodMatchLabel || 'Good Match',
      type: TagType.GOOD_MATCH,
      color: getColor(TagType.GOOD_MATCH, props, defaultColor),
    });
  }

  if (isVirtual) {
    tags.push({
      label: virtualLabel || 'Virtual',
      type: TagType.VIRTUAL,
      color: getColor(TagType.VIRTUAL, props, defaultColor),
    });
  }
  if (status?.toLowerCase() === 'enrolling') {
    tags.push({
      label: enrollingLabel || 'Enrolling',
      type: TagType.ENROLLING,
      color: getColor(TagType.ENROLLING, props, defaultColor),
    });
  } else if (status?.toLowerCase() === 'notyetenrolling') {
    tags.push({
      label: notYetEnrollingLabel || 'Not Yet Enrolling',
      type: TagType.NOT_YET_ENROLLING,
      color: getColor(TagType.NOT_YET_ENROLLING, props, defaultColor),
    });
  } else if (status) {
    const typeFromSearch = getDefaultStatusType();
    tags.push({
      label: trial.raw.trialenrollingstatus,
      type: typeFromSearch,
      color: getColor(typeFromSearch, props, defaultColor),
    });
  }
  return tags;
};

const getDefaultStatusType = (): TagType => {
  return TagType.NOT_YET_ENROLLING;
};
